// CommonLayout.js
import React from "react";
import { FC } from "react";
import { NavLink } from "react-router-dom";
import AccountSideNav from "components/AccountSideNav/AccountSideNav";

export interface CommonLayoutProps {
  children?: React.ReactNode;
}

const CommonLayout: FC<CommonLayoutProps> = ({ children }) => {
  return (
    <div className="flex h-full"> 
      {/* AccountSideNav */}
      <AccountSideNav />

      {/* Main Content */}
      <div className="flex-1 ml-8">
        <div className="max-w-6xl mx-auto pt-14 sm:pt-26 pb-24 lg:pb-32">
          {children}
        </div>
      </div>
    </div>
  );
};

export default CommonLayout;
